import script from "./WelcomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomePage.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomePage.vue?vue&type=style&index=0&id=ea5310e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea5310e2"]])

export default __exports__